import { useDispatch } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import { TableCell, IconButton, Tooltip } from '@mui/material';
import { withdrawInvite } from '../../../reducers/AdminUserMgtReducer';

const InviteActionCell = ({ actionId }) => {
  const dispatch = useDispatch();
  const handleWithdrawClick = () => {
    dispatch(withdrawInvite(actionId));
  };

  return (
    <TableCell
      align="left"
      sx={{ color: '#22467F', padding: '4px', width: 'auto', whiteSpace: 'nowrap', overflow: 'hidden' }}
    >
      <Tooltip title="Withdraw User Invite">
        <IconButton
          sx={{
            color: 'red',
            size: 'small',
          }}
          onClick={handleWithdrawClick}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </TableCell>
  );
};
export default InviteActionCell;
